import mutationTypes from './mutation-types'

export default {
  [mutationTypes.SET_ORDER] (state, order) {
    state.order = order;
  }
}
